'use strict';

(function () {
  var slide = document.querySelector('.slideshow');

  if (!slide) {
    return;
  }

  var controls = slide.querySelector('.slider__arrows');
  var controlsNext = slide.querySelector('.slider__arrow-right');
  var controlsPrev = slide.querySelector('.slider__arrow-left');

  var slideOptions = {
    type: 'carousel',
    perView: 1
  };

  var slideshow = function slideshow() {
    var glide = new Glide('.slideshow__wrap', slideOptions);
    glide.mount();

    // controls
    if (controls) {
      controlsNext.addEventListener('click', function () {
        glide.go('>');
      });

      controlsPrev.addEventListener('click', function () {
        glide.go('<');
      });
    }

    //set tabindex to -1 for invisible slide focusable content
    var update_slide_content_tabindex = function update_slide_content_tabindex() {
      slide.querySelectorAll('.glide__slide--active a.btn').forEach(function (e) {
        e.setAttribute('tabindex', '0');
      });
      slide.querySelectorAll('.glide__slide:not(.glide__slide--active) a.btn').forEach(function (e) {
        e.setAttribute('tabindex', '-1');
      });
    };
    glide.on('move.after', update_slide_content_tabindex);
    update_slide_content_tabindex(); //init
  };

  slideshow();
})();